import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../components/Layout';
// const NAV = [
//   { icon: '⬡',  label: 'Dashboard',       path: '/dashboard'      },
//   { icon: '👥',  label: 'User Management', path: '/user-management' },
//   { icon: '🌤️', label: 'Season Name',      path: '/season-name'    },
//   { icon: '📅',  label: 'Season Duration', path: '/season-duration' },
//   { icon: '🚗',  label: 'Car Group',       path: '/car-group'       },
//   { icon: '🚘',  label: 'Manage Cars',     path: '/manage-cars'     },
//   { icon: '📋',  label: 'Bookings',        path: '/bookings'        },
//   { icon: '👤',  label: 'Customers',       path: '/customers'       },
//   { icon: '💳',  label: 'Payments',        path: '/payments'        },
// ];
const BASE_URL = 'http://192.168.0.57:5000';
const YES_NO = [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }];
const DOORS  = [2, 3, 4, 5];
const PASS   = [1,2,3,4,5,6,7,8,9];
const LUGG   = [0,1,2,3,4,5,6,7,8];

const EMPTY_FORM = {
  cat_id: 3, group_id: '', car_name: '', car_brand: '', No_of_Car: 1,
  car_desc: '', car_passgrno: 5, car_luggno: 2, car_engcapacity: '',
  car_doors: 4, car_transmission: 'Automatic', car_powrsteering: 1,
  car_cntralLocking: 1, car_airconditionr: 1, car_stereo: 0,
  car_airbag: 0, car_elctricwindows: 1, reverse_cam: 0,
  apple_car_play: 0, android_player: 0, radio: 0,
  transfer: 0, car_dispinhome: 0, image_alt: ''
};

export default function ManageCars() {
  const navigate = useNavigate();

  // ── Sidebar ──
  const [sideOpen,   setSideOpen]   = useState(true);
  const [activePage, setActivePage] = useState('Manage Cars');
  const [user,       setUser]       = useState(null);

  // ── Dropdowns ──
  const [groups,     setGroups]     = useState([]);

  // ── Table ──
  const [data,       setData]       = useState([]);
  const [page,       setPage]       = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total,      setTotal]      = useState(0);
  const [search,     setSearch]     = useState('');
  const [filterGroup, setFilterGroup] = useState(0);
  const [loading,    setLoading]    = useState(false);

  // ── Modal ──
  const [modalOpen,  setModalOpen]  = useState(false);
  const [form,       setForm]       = useState(EMPTY_FORM);
  const [editId,     setEditId]     = useState(null);
  const [saving,     setSaving]     = useState(false);
  const [imageFile,  setImageFile]  = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const fileRef = useRef();

  // ── View modal ──
  const [viewCar,    setViewCar]    = useState(null);

  // ── Auth ──
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/login'); return; }
    setUser(JSON.parse(localStorage.getItem('user') || 'null'));
  }, []);

  // ── Load groups ──
  useEffect(() => {
    API.get('/cargroup', { params: { page: 1, limit: 100 } })
      .then(r => setGroups(r.data.data || []))
      .catch(() => {});
  }, []);

  // ── Fetch cars ──
  const fetchData = useCallback((pg = page, q = search, gid = filterGroup) => {
    setLoading(true);
    API.get('/cars', { params: { page: pg, limit: 10, search: q, group_id: gid } })
      .then(r => {
        setData(r.data.data);
        setTotalPages(r.data.totalPages);
        setTotal(r.data.total);
      })
      .catch(() => toast.error('Failed to load cars'))
      .finally(() => setLoading(false));
  }, [page, search, filterGroup]);

  useEffect(() => { fetchData(page, search, filterGroup); }, [page]);

  // debounce search
  useEffect(() => {
    const t = setTimeout(() => { setPage(1); fetchData(1, search, filterGroup); }, 300);
    return () => clearTimeout(t);
  }, [search]);

  // ── Open add ──
  const openAdd = () => {
    setForm(EMPTY_FORM); setEditId(null);
    setImageFile(null); setImagePreview('');
    setModalOpen(true);
  };

  // ── Open edit ──
  const openEdit = (row) => {
    setForm({
      cat_id: row.cat_id || 3,
      group_id: row.group_id,
      car_name: row.car_name,
      car_brand: row.car_brand || '',
      No_of_Car: row.No_of_Car || 1,
      car_desc: row.car_desc || '',
      car_passgrno: row.car_passgrno || 5,
      car_luggno: row.car_luggno || 2,
      car_engcapacity: row.car_engcapacity || '',
      car_doors: row.car_doors || 4,
      car_transmission: row.car_transmission || 'Automatic',
      car_powrsteering: row.car_powrsteering || 0,
      car_cntralLocking: row.car_cntralLocking || 0,
      car_airconditionr: row.car_airconditionr || 0,
      car_stereo: row.car_stereo || 0,
      car_airbag: row.car_airbag || 0,
      car_elctricwindows: row.car_elctricwindows || 0,
      reverse_cam: row.reverse_cam || 0,
      apple_car_play: row.apple_car_play || 0,
      android_player: row.android_player || 0,
      radio: row.radio || 0,
      transfer: row.transfer || 0,
      car_dispinhome: row.car_dispinhome || 0,
      image_alt: row.image_alt || ''
    });
    setEditId(row.car_id);
    setImageFile(null);
    setImagePreview(row.car_image ? `${BASE_URL}/${row.car_image}` : '');
    setModalOpen(true);
  };

  // ── Form change ──
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? (checked ? 1 : 0) : value }));
  };

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  // ── Submit ──
  const handleSubmit = async () => {
    if (!form.car_name.trim()) { toast.warning('Enter car name');  return; }
    if (!form.group_id)        { toast.warning('Select a group'); return; }

    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (imageFile) fd.append('car_image', imageFile);

      if (editId) {
        await API.put(`/cars/${editId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Car updated successfully');
      } else {
        await API.post('/cars', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        toast.success('Car added successfully');
      }
      setModalOpen(false);
      fetchData(page, search, filterGroup);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Operation failed');
    }
    setSaving(false);
  };

  // ── Delete ──
  const handleDelete = async (id) => {
    if (!window.confirm('Delete this car?')) return;
    try {
      await API.delete(`/cars/${id}`);
      toast.success('Car deleted successfully');
      fetchData(page, search, filterGroup);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Delete failed');
    }
  };

  // ── Toggle home offer ──
  const toggleHomeOffer = async (row) => {
    try {
      await API.patch(`/cars/${row.car_id}/home-offer`, { status: row.display_home_offer });
      fetchData(page, search, filterGroup);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Update failed');
    }
  };

  const logout = () => { localStorage.clear(); navigate('/login'); };

  // ── Select helper ──
  const Sel = ({ name, value, options, onChange }) => (
    <select name={name} value={value} onChange={onChange} style={S.input}>
      {options.map(o => (
        <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>
      ))}
    </select>
  );

  return (
    <Layout activePage="Car Details">
    {/* <div style={S.root}> */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ── Sidebar ── */}
      {/* <aside style={{ ...S.sidebar, width: sideOpen ? 220 : 68 }}>
        <div style={S.sideTop}>
          <div style={S.logoWrap}>
            <div style={S.logoIcon}>🚗</div>
            {sideOpen && <span style={S.logoText}>Orisys</span>}
          </div>
          <button style={S.collapseBtn} onClick={() => setSideOpen(p => !p)}>
            {sideOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav style={{ flex: 1 }}>
          {NAV.map(n => (
            <div key={n.label}
              style={{ ...S.navItem, ...(activePage === n.label ? S.navActive : {}) }}
              onClick={() => { setActivePage(n.label); navigate(n.path); }}
            >
              <span style={S.navIcon}>{n.icon}</span>
              {sideOpen && <span style={S.navLabel}>{n.label}</span>}
            </div>
          ))}
        </nav>
        <div style={S.sideBottom}>
          {sideOpen && (
            <div style={S.userChip}>
              <div style={S.avatar}>{user?.user_name?.[0] || 'A'}</div>
              <div>
                <div style={S.userName}>{user?.user_name || 'Admin'}</div>
                <div style={S.userRole}>Administrator</div>
              </div>
            </div>
          )}
          <button style={S.logoutBtn} onClick={logout}>
            <span>🚪</span>{sideOpen && <span style={{ marginLeft: 8 }}>Logout</span>}
          </button>
        </div>
      </aside> */}

      {/* ── Main ── */}
      {/* <main style={{ ...S.main, marginLeft: sideOpen ? 5 : 5 }}> */}

        <div style={S.topbar}>
          <div>
            <h2 style={S.title}>Manage Cars</h2>
            <p style={S.subtitle}>Add and manage vehicle listings</p>
          </div>
          <button style={S.addBtn} onClick={openAdd}>+ Add Car</button>
        </div>

        {/* Filters */}
        <div style={S.filterRow}>
          <div style={S.searchWrap}>
            <span style={{ color: '#aaa', fontSize: 14 }}>🔍</span>
            <input
              type="text" placeholder="Search car name or brand..."
              value={search} onChange={e => setSearch(e.target.value)}
              style={S.searchInput}
            />
            {search && <button style={S.clearBtn} onClick={() => setSearch('')}>✕</button>}
          </div>
          <select
            value={filterGroup}
            onChange={e => { const v = parseInt(e.target.value); setFilterGroup(v); setPage(1); fetchData(1, search, v); }}
            style={S.filterSelect}
          >
            <option value={0}>— All Groups —</option>
            {groups.map(g => <option key={g.group_id} value={g.group_id}>{g.group_name}</option>)}
          </select>
        </div>

        {/* Table Card */}
        <div style={S.card}>
          <div style={{ overflowX: 'auto' }}>
            <table style={S.table}>
              <thead>
                <tr style={S.theadRow}>
                  <th style={S.th}>#</th>
                  {/* <th style={S.th}>Image</th> */}
                  <th style={S.th}>Car Name</th>
                  {/* <th style={S.th}>Brand</th> */}
                  <th style={S.th}>Group</th>
                  <th style={S.th}>Stock</th>
                  <th style={S.th}>Display Home</th>
                  <th style={S.th}>Transfer</th>
                  <th style={S.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={9} style={S.emptyCell}>Loading…</td></tr>
                ) : data.length === 0 ? (
                  <tr><td colSpan={9} style={S.emptyCell}>No cars found</td></tr>
                ) : data.map((row, i) => (
                  <tr key={row.car_id} style={S.tr}>
                    <td style={S.td}><span style={S.serial}>{(page-1)*10+i+1}</span></td>
                    {/* <td style={S.td}>
                      {row.car_image
                        ? <img src={`${BASE_URL}/${row.car_image}`} alt={row.car_name}
                            style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 6 }} />
                        : <div style={S.noImg}>🚗</div>}
                    </td> */}
                    <td style={{...S.td, textAlign: 'center',width: '17%' }}><span style={S.nameChip}>{row.car_name}</span></td>
                    {/* <td style={{ ...S.td, color: '#888', fontSize: 12, textAlign: 'center',width: '17%' }}>{row.car_brand}</td> */}
                    <td style={{ ...S.td, textAlign: 'center',width: '17%' }}><span style={S.groupChip}>{row.group_name}</span></td>
                    <td style={S.td}><span style={S.stockChip}>{row.No_of_Car}</span></td>
                    <td style={S.td}>
                      <span style={{ ...S.badge, background: row.car_dispinhome ? '#f0fff6' : '#f8f8f8',
                        color: row.car_dispinhome ? '#1a9e5c' : '#aaa' }}>
                        {row.car_dispinhome ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td style={S.td}>
                      <span style={{ ...S.badge, background: row.transfer ? '#f0f8ff' : '#f8f8f8',
                        color: row.transfer ? '#1a6eb5' : '#aaa' }}>
                        {row.transfer ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td style={S.td}>
                      <button style={S.viewBtn} onClick={() => setViewCar(row)}>View</button>
                      <button style={S.editBtn} onClick={() => openEdit(row)}>Edit</button>
                      <button style={S.delBtn}  onClick={() => handleDelete(row.car_id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={S.pagination}>
            <span style={S.paginInfo}>
              {total > 0 ? `Showing ${(page-1)*10+1}–${Math.min(page*10, total)} of ${total}` : ''}
            </span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button style={S.pgBtn} disabled={page === 1} onClick={() => setPage(p => p-1)}>← Prev</button>
              <span style={S.paginInfo}>Page {page} / {totalPages || 1}</span>
              <button style={S.pgBtn} disabled={page === totalPages || totalPages === 0}
                onClick={() => setPage(p => p+1)}>Next →</button>
            </div>
          </div>
        </div>
      {/* </main> */}

      {/* ── Add / Edit Modal ── */}
      {modalOpen && (
        <div style={S.overlay} onClick={() => !saving && setModalOpen(false)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>
            <div style={S.modalHead}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
                {editId ? '✏️ Edit Car' : '➕ Add New Car'}
              </h3>
              <button style={S.closeBtn} onClick={() => !saving && setModalOpen(false)}>✕</button>
            </div>

            <div style={S.modalBody}>

              {/* Section: Basic Info */}
              <div style={S.section}>Basic Information</div>
              <div style={S.grid2}>
                <div style={S.fg}>
                  <label style={S.label}>Car Group <span style={S.req}>*</span></label>
                  <select name="group_id" value={form.group_id} onChange={handleChange} style={S.input}>
                    <option value="">— Select Group —</option>
                    {groups.map(g => <option key={g.group_id} value={g.group_id}>{g.group_name}</option>)}
                  </select>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Car Name <span style={S.req}>*</span></label>
                  <input name="car_name" value={form.car_name} onChange={handleChange} placeholder="e.g. Toyota Camry" style={S.input} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Brand</label>
                  <input name="car_brand" value={form.car_brand} onChange={handleChange} placeholder="e.g. Toyota" style={S.input} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Number of Cars</label>
                  <input name="No_of_Car" type="number" min={1} value={form.No_of_Car} onChange={handleChange} style={S.input} />
                </div>
              </div>

              <div style={S.fg}>
                <label style={S.label}>Description</label>
                <textarea name="car_desc" value={form.car_desc} onChange={handleChange}
                  placeholder="Car description..." rows={3}
                  style={{ ...S.input, resize: 'vertical', fontFamily: 'inherit' }} />
              </div>

              {/* Section: Specs */}
              <div style={S.section}>Specifications</div>
              <div style={S.grid4}>
                <div style={S.fg}>
                  <label style={S.label}>Passengers</label>
                  <Sel name="car_passgrno" value={form.car_passgrno} options={PASS.map(v=>({value:v,label:v}))} onChange={handleChange} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Luggage</label>
                  <Sel name="car_luggno" value={form.car_luggno} options={LUGG.map(v=>({value:v,label:v}))} onChange={handleChange} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Doors</label>
                  <Sel name="car_doors" value={form.car_doors} options={DOORS.map(v=>({value:v,label:v}))} onChange={handleChange} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Engine Capacity</label>
                  <input name="car_engcapacity" value={form.car_engcapacity} onChange={handleChange} placeholder="e.g. 2000cc" style={S.input} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Transmission</label>
                  <select name="car_transmission" value={form.car_transmission} onChange={handleChange} style={S.input}>
                    <option value="Automatic">Automatic</option>
                    <option value="Manual">Manual</option>
                  </select>
                </div>
              </div>

              {/* Section: Features */}
              <div style={S.section}>Features</div>
              <div style={S.grid4}>
                {[
                  { name: 'car_powrsteering',  label: 'Power Steering'    },
                  { name: 'car_cntralLocking', label: 'Central Locking'   },
                  { name: 'car_airconditionr', label: 'Air Conditioning'  },
                  { name: 'car_stereo',        label: 'Stereo'            },
                  { name: 'car_airbag',        label: 'Airbag'            },
                  { name: 'car_elctricwindows',label: 'Electric Windows'  },
                  { name: 'reverse_cam',       label: 'Reverse Camera'    },
                  { name: 'apple_car_play',    label: 'Apple CarPlay'     },
                  { name: 'android_player',    label: 'Android Player'    },
                  { name: 'radio',             label: 'Radio'             },
                ].map(f => (
                  <div key={f.name} style={S.fg}>
                    <label style={S.label}>{f.label}</label>
                    <Sel name={f.name} value={form[f.name]} options={YES_NO} onChange={handleChange} />
                  </div>
                ))}
              </div>

              {/* Section: Settings */}
              <div style={S.section}>Settings</div>
              <div style={S.grid4}>
                <div style={S.fg}>
                  <label style={S.label}>Available for Transfer</label>
                  <Sel name="transfer" value={form.transfer} options={YES_NO} onChange={handleChange} />
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Display on Home Page</label>
                  <Sel name="car_dispinhome" value={form.car_dispinhome} options={YES_NO} onChange={handleChange} />
                </div>
              </div>

              {/* Section: Image */}
              <div style={S.section}>Car Image</div>
              <div style={S.grid2}>
                <div style={S.fg}>
                  <label style={S.label}>Upload Image</label>
                  <input ref={fileRef} type="file" accept="image/*" onChange={handleImageChange}
                    style={{ fontSize: 13, fontFamily: 'inherit' }} />
                  <span style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>JPG / PNG / WEBP, max 5MB</span>
                </div>
                <div style={S.fg}>
                  <label style={S.label}>Image Alt Text</label>
                  <input name="image_alt" value={form.image_alt} onChange={handleChange} placeholder="Alt text for SEO" style={S.input} />
                </div>
              </div>

              {imagePreview && (
                <div style={{ marginTop: 12 }}>
                  <img src={imagePreview} alt="Preview"
                    style={{ width: 160, height: 100, objectFit: 'cover', borderRadius: 10, border: '1px solid #eee' }} />
                </div>
              )}

            </div>

            <div style={S.modalFoot}>
              <button style={S.cancelBtn} onClick={() => !saving && setModalOpen(false)}>Cancel</button>
              <button style={{ ...S.submitBtn, opacity: saving ? 0.7 : 1 }}
                onClick={handleSubmit} disabled={saving}>
                {saving ? 'Saving…' : editId ? 'Update Car' : 'Add Car'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── View Modal ── */}
      {viewCar && (
        <div style={S.overlay} onClick={() => setViewCar(null)}>
          <div style={{ ...S.modalBox, maxWidth: 500 }} onClick={e => e.stopPropagation()}>
            <div style={S.modalHead}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>🚗 {viewCar.car_name}</h3>
              <button style={S.closeBtn} onClick={() => setViewCar(null)}>✕</button>
            </div>
            <div style={S.modalBody}>
              {viewCar.car_image && (
                <img src={`${BASE_URL}/${viewCar.car_image}`} alt={viewCar.car_name}
                  style={{ width: '100%', height: 200, objectFit: 'cover', borderRadius: 10, marginBottom: 16 }} />
              )}
              <div style={S.grid2}>
                {[
                  ['Group',        viewCar.group_name],
                  ['Brand',        viewCar.car_brand],
                  ['Stock',        viewCar.No_of_Car],
                  ['Passengers',   viewCar.car_passgrno],
                  ['Luggage',      viewCar.car_luggno],
                  ['Doors',        viewCar.car_doors],
                  ['Engine',       viewCar.car_engcapacity],
                  ['Transmission', viewCar.car_transmission],
                  ['A/C',          viewCar.car_airconditionr ? 'Yes' : 'No'],
                  ['Airbag',       viewCar.car_airbag ? 'Yes' : 'No'],
                  ['Transfer',     viewCar.transfer ? 'Yes' : 'No'],
                  ['Home Page',    viewCar.car_dispinhome ? 'Yes' : 'No'],
                ].map(([k, v]) => (
                  <div key={k} style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 11, color: '#aaa', fontWeight: 600, textTransform: 'uppercase' }}>{k}</div>
                    <div style={{ fontSize: 13, color: '#333', fontWeight: 600 }}>{v || '—'}</div>
                  </div>
                ))}
              </div>
              {viewCar.car_desc && (
                <div style={{ marginTop: 12, fontSize: 13, color: '#666', lineHeight: 1.6 }}>{viewCar.car_desc}</div>
              )}
            </div>
            <div style={S.modalFoot}>
              <button style={S.submitBtn} onClick={() => setViewCar(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    {/* </div> */}
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },

  /* Sidebar */
//   sidebar: { background: '#1a1d2e', color: '#fff', display: 'flex', flexDirection: 'column',
//     position: 'fixed', height: '100vh', transition: 'width 0.25s', overflow: 'hidden', zIndex: 100 },
//   sideTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 16px 16px' },
//   logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
//   logoIcon: { width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
//     borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 },
//   logoText: { fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', whiteSpace: 'nowrap' },
//   collapseBtn: { background: 'rgba(255,255,255,0.08)', border: 'none', color: '#aaa',
//     borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 11, flexShrink: 0 },
//   navItem: { display: 'flex', alignItems: 'center', gap: 12,
//     paddingTop: '11px', paddingBottom: '11px', paddingLeft: '16px', paddingRight: '16px',
//     cursor: 'pointer', borderRadius: 10, margin: '2px 10px',
//     color: '#aaa', fontSize: 14, transition: 'all 0.15s', whiteSpace: 'nowrap' },
//   navActive: { background: 'rgba(99,179,237,0.12)', color: '#63b3ed',
//     borderLeft: '3px solid #63b3ed', paddingLeft: '13px' },
//   navIcon: { fontSize: 16, flexShrink: 0 },
//   navLabel: { fontWeight: 500 },
//   sideBottom: { padding: '16px', borderTop: '1px solid rgba(255,255,255,0.07)' },
//   userChip: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 },
//   avatar: { width: 36, height: 36, background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
//     borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
//     fontWeight: 800, fontSize: 15, flexShrink: 0 },
//   userName: { fontSize: 13, fontWeight: 700, color: '#fff' },
//   userRole: { fontSize: 11, color: '#777' },
//   logoutBtn: { width: '100%', background: 'rgba(255,100,100,0.12)', border: '1px solid rgba(255,100,100,0.2)',
//     color: '#ff6b6b', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 13,
//     display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'inherit' },

  /* Main */
  main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
  topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
  addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },

  /* Filters */
  filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
  searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
    border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
    flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
  searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
    fontFamily: 'inherit', color: '#333', background: 'transparent' },
  clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
  filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
    background: '#fff', minWidth: 180 },

  /* Card + Table */
  card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#fafafa' },
  th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
    textAlign: 'center', borderBottom: '2px solid #f0f0f0',
    textTransform: 'uppercase', letterSpacing: '0.5px' },
  tr: { transition: 'background 0.12s' },
  td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
  emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
  noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },

  /* Chips */
  serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
  nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
  groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
  stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
  badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },

  /* Action buttons */
  viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
    border: '1px solid #b8f0d0', padding: '4px 12px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', padding: '4px 12px',
    borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  delBtn: { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
    padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },

  /* Pagination */
  pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
  paginInfo: { fontSize: 12, color: '#999' },
  pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
    border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
    fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },

  /* Modal */
  overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
    display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
  modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
    display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
  modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
  modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
  modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
    padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
  closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
    borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
  cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
    border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
  submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },

  /* Form */
  section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
    letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
    borderBottom: '1.5px solid #f3f2ff' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
  fg: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { fontSize: 12, fontWeight: 600, color: '#555' },
  req: { color: '#ff6b6b' },
  input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',
    boxSizing: 'border-box' },
};
